import React from 'react'
import { List, useListRepository } from 'elentari'
import analistaUnidadeNegocioRepository from './analistaUnidadeNegocioRepository'

export default function AnalistaUnidadeNegocio(props) {
  const listOptions = {
    defaultOrder: 'data',
    fields: {
      id: {
        label: 'Id'
      },
      analista: {
        label: 'Analista',
        format: analista => analista.usuario
      }
    }
  }
  const listHook = useListRepository({
    repository: analistaUnidadeNegocioRepository,
    path: 'analistas',
    forceRemove: true
  })
  listHook.onClickEdit = null
  listHook.onClickNew = props.onClickNew

  delete listHook.undoRemove
  listHook.deleteFItem = listHook.removeItem
  delete listHook.removeItem
  return (
    <List
      {...props}
      {...listHook}
      hideDownloadIcon
      removeItem={null}
      undoRemove={null}
      onClickView={null}
      deleteFItem={listHook.deleteFItem}
      listOptions={listOptions}
    />
  )
}
